<body>

  <div class="login-card">


    <div class="logo">
      <img src="src/assets/img/demologo1.png" alt="not found">
    </div>
    <div class="err" id="error">
      <h3 style="text-align: center;"> {{sms}} </h3>

    </div>
    <h1>Recover Password</h1>
    <br>
    <form>
      <label>New Password</label>
      <div class="user">
        <input type="password" name="password" [(ngModel)]="screen_details.newpass" id="npass" [pattern]="emailPattern" #email="ngModel">
        <span *ngIf="email.errors?.pattern" style="color: red"> UserName is invalid</span>
      </div>
      <label>Confirm Pasword</label>
      <div class="user">
        <input type="password" name="cnfmpass" [(ngModel)]="screen_details.cnfmpass" id="mobile" (blur)="checkpass()">
        <span *ngIf="email.errors?.pattern" style="color: red"> UserName is invalid</span>
      </div>
      <div class="logdiv">
        <span><a routerLink="/login">login</a></span>
        <span class="text-right">
          <input type="submit" name="Submit" class="login login-submit" (click)="submitdata()" value="Login" [disabled]="email.errors?.pattern">
        </span>
      </div>

    </form>



  </div>
</body>